(function($) {
    class UserFunctionalityHandler {
        constructor() {
            this.optionalSpanElements = document.querySelectorAll('span.optional');
            this.$toggleR1FieldLabel = $('#toggle_r1_field label');
            this.$billingCompanyField = $('#billing_company_field');
            this.$billingOibField = $('#billing_oib_field');
            this.$toggleR1 = $('#toggle_r1');

            this.init();
        }

        init() {
            this.removeOptionalSpans();
            this.initializeUserFunctionality();
        }

        removeOptionalSpans() {
            this.optionalSpanElements.forEach(span => span.remove());
        }

        handleMPFunctionality() {
            if(this.$toggleR1FieldLabel.length != 0 
                && this.$billingCompanyField.length != 0 
                && this.$billingOibField.length != 0 ){
                this.$toggleR1FieldLabel.addClass('woocommerce-form__label woocommerce-form__label-for-checkbox');
                this.$billingCompanyField.hide();
                this.$billingOibField.hide();
    
                this.$toggleR1.change(() => {
                    const isChecked = this.$toggleR1.is(':checked');
    
                    if (isChecked) {
                        this.$billingCompanyField.show();
                        this.$billingOibField.show();
                    } else {
                        this.$billingCompanyField.hide();
                        this.$billingOibField.hide();
                    }
                });
            }
        }

        initializeUserFunctionality() {
            this.handleMPFunctionality();
        }
    }

    $(document).ready(() => {
        new UserFunctionalityHandler();
    });

})(jQuery);